var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalCertificateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_186_7555)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 40,
    height: 40,
    rx: 10,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 39,
    height: 39,
    rx: 9.5,
    stroke: "#6366F1",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_186_7555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9905 22.4601C21.6274 22.4601 20.3945 21.2272 20.3945 15.864C20.3945 15.7646 20.355 15.6693 20.2847 15.599C20.2144 15.5287 20.1191 15.4893 20.0197 15.4893C19.9203 15.4893 19.825 15.5287 19.7547 15.599C19.6844 15.6693 19.645 15.7646 19.645 15.864C19.645 21.2272 18.4121 22.4601 13.0489 22.4601C12.9996 22.4599 12.9507 22.4694 12.905 22.4882C12.8594 22.5069 12.8179 22.5345 12.7829 22.5693C12.748 22.6041 12.7202 22.6455 12.7013 22.6911C12.6824 22.7366 12.6726 22.7855 12.6726 22.8348C12.6726 22.8842 12.6824 22.933 12.7013 22.9786C12.7202 23.0242 12.748 23.0656 12.7829 23.1004C12.8179 23.1352 12.8594 23.1628 12.905 23.1815C12.9507 23.2002 12.9996 23.2098 13.0489 23.2096C18.4121 23.2096 19.645 24.4431 19.645 29.8063C19.645 29.9057 19.6844 30.001 19.7547 30.0713C19.825 30.1415 19.9203 30.181 20.0197 30.181C20.1191 30.181 20.2144 30.1415 20.2847 30.0713C20.355 30.001 20.3945 29.9057 20.3945 29.8063C20.3945 24.4431 21.6274 23.2096 26.9905 23.2096C27.0399 23.2098 27.0888 23.2002 27.1344 23.1815C27.1801 23.1628 27.2216 23.1352 27.2565 23.1004C27.2915 23.0656 27.3192 23.0242 27.3382 22.9786C27.3571 22.933 27.3668 22.8842 27.3668 22.8348C27.3668 22.7855 27.3571 22.7366 27.3382 22.6911C27.3192 22.6455 27.2915 22.6041 27.2565 22.5693C27.2216 22.5345 27.1801 22.5069 27.1344 22.4882C27.0888 22.4694 27.0399 22.4599 26.9905 22.4601Z",
    fill: "#6366F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2976 19.8008C27.1982 19.8008 27.1029 19.7613 27.0326 19.691C26.9624 19.6207 26.9229 19.5254 26.9229 19.426C26.9229 16.699 26.3711 16.1472 23.644 16.1472C23.5447 16.1472 23.4493 16.1077 23.3791 16.0375C23.3088 15.9672 23.2693 15.8719 23.2693 15.7725C23.2693 15.6731 23.3088 15.5777 23.3791 15.5075C23.4493 15.4372 23.5447 15.3977 23.644 15.3977C26.3711 15.3977 26.9229 14.8459 26.9229 12.1189C26.9229 12.0195 26.9623 11.9242 27.0326 11.8539C27.1029 11.7836 27.1982 11.7441 27.2976 11.7441C27.397 11.7441 27.4923 11.7836 27.5626 11.8539C27.6329 11.9242 27.6724 12.0195 27.6724 12.1189C27.6724 14.8459 28.2241 15.3977 30.9512 15.3977C31.0506 15.3977 31.1459 15.4372 31.2162 15.5075C31.2864 15.5777 31.3259 15.6731 31.3259 15.7725C31.3259 15.8719 31.2864 15.9672 31.2162 16.0375C31.1459 16.1077 31.0506 16.1472 30.9512 16.1472C28.2241 16.1472 27.6724 16.699 27.6724 19.426C27.6723 19.5254 27.6329 19.6207 27.5626 19.691C27.4923 19.7613 27.397 19.8008 27.2976 19.8008ZM26.1355 15.7725C26.6597 15.9933 27.0768 16.4104 27.2976 16.9346C27.5185 16.4104 27.9355 15.9933 28.4597 15.7725C27.9355 15.5516 27.5185 15.1346 27.2976 14.6104C27.0768 15.1345 26.6597 15.5516 26.1355 15.7725Z",
    fill: "#6366F1"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_186_7555",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0509804 0 0 0 0 0.0509804 0 0 0 0 0.0705882 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_186_7555"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_186_7555",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_186_7555"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(12 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalCertificateIcon);
export default __webpack_public_path__ + "static/media/total-certificate-icon.3af302cc6a4c4bb0c3e8852fa6123c5c.svg";
export { ForwardRef as ReactComponent };